import React, { useEffect, useState } from "react";
import axios from "axios";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { checkFilterItem, fetchFilterData } from "../../../../utils/fetchFilterData";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import MaterialPagination from "../../../styles/materialPagination";
import TelegramInvoicesFilter from "./TelegramInvoicesFilter";
import FilterAppliedList from "../../../elements/filter/FilterAppliedList";
import TelegramInvoicesList from "./TelegramInvoicesList";

const TelegramInvoicesContainer = () => {
  const { t } = useTranslation("telegramBotPage");
  const history = useHistory();

  const [filterData, setFilterData] = useState({
    "currentTab": checkFilterItem(history, "currentTab", "invoices", false, true),
    "page": checkFilterItem(history, "page", 1, true),
    "limit": checkFilterItem(history, "limit", 20, true),
    "projectId": checkFilterItem(history, "projectId", null),
    "chatId": checkFilterItem(history, "chatId", null),
    "managerId": checkFilterItem(history, "managerId", null),
    "type": checkFilterItem(history, "type", null),
    "status": checkFilterItem(history, "status", null),
    "invoiceId": checkFilterItem(history, "invoiceId", null),
  });

  const [bots, setBots] = useState([]);
  const [botsLoading, setBotsLoading] = useState(false);
  const [chats, setChats] = useState([]);
  const [chatsLoading, setChatsLoading] = useState(false);
  const [managers, setManagers] = useState([]);
  const [invoices, setInvoices] = useState(null);
  const [totalPageCount, setTotalPageCount] = useState(0);
  const [notification, setNotification] = useState({ visible: false, type: "", message: "" });

  const fetchBots = () => {
    if (botsLoading) return;
    setBotsLoading(true);
    axios.get("/api/telegram/bots", userAuthenticationConfig()).then(r => setBots(r.data || [])).catch(() => setBots([])).finally(() => setBotsLoading(false));
  };

  const fetchChats = () => {
    if (chatsLoading) return;
    setChatsLoading(true);
    axios.get("/api/telegram/chats", userAuthenticationConfig()).then(r => setChats(r.data["hydra:member"] || [])).catch(() => setChats([])).finally(() => setChatsLoading(false));
  };

  const fetchManagers = () => {
    if (!filterData.projectId) {
      setManagers([]);
      return;
    }
    axios.get(`/api/telegram/managers?projectId=${filterData.projectId}`, userAuthenticationConfig()).then(r => setManagers(r.data["hydra:member"] || [])).catch(() => setManagers([]));
  };

  useEffect(() => { fetchManagers(); }, [filterData.projectId]);

  const fetchInvoices = () => {
    const filterUrl = fetchFilterData(filterData);
    history.replace(filterUrl);
    setInvoices(null);
    axios.get(`/api/telegram/invoices${filterUrl}`, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setInvoices(response.data["hydra:member"]);
        setTotalPageCount(response.data["hydra:totalPageCount"] || 0);
      }
    }).catch(error => {
      setNotification({
        visible: true,
        type: "error",
        message: error?.response?.data?.message || t("invoices.errors.load")
      });
      setInvoices([]);
    });
  };

  useEffect(() => { fetchInvoices(); }, [filterData]);

  const handleFilterOpen = () => {
    fetchBots();
    fetchChats();
  };

  return (
    <>
      <Notification notification={notification} setNotification={setNotification} />
      <div className="content-head">
        <TelegramInvoicesFilter
          filterData={filterData}
          setFilterData={setFilterData}
          bots={bots}
          botsLoading={botsLoading}
          chats={chats}
          chatsLoading={chatsLoading}
          managers={managers}
          onOpen={handleFilterOpen}
          t={t}
        />
      </div>
      <FilterAppliedList
        filterData={filterData}
        setFilterData={setFilterData}
      />
      <TelegramInvoicesList
        invoices={invoices}
        setNotification={setNotification}
        t={t}
      />
      {totalPageCount > 1 && (
        <MaterialPagination
          count={totalPageCount}
          shape="rounded"
          page={filterData.page}
          onChange={(e, page) => setFilterData(prev => ({ ...prev, page }))}
        />
      )}
    </>
  );
};

export default TelegramInvoicesContainer;
